import * as React from 'react';
import * as styles from './ParagraphSecondary.scss';

interface Props {
    children?: any;
    alignText?: string;
    innerHtml?: boolean;
}

const ParagraphSecondary: React.SFC<Props> = props => {
    const alignTextClass = props.alignText ? styles[props.alignText] : '';
    return props.innerHtml ? (
        <p
            dangerouslySetInnerHTML={{ __html: props.children }}
            className={styles.paragraphSecondary + ' ' + alignTextClass}
        />
    ) : (
        <p className={styles.paragraphSecondary + ' ' + alignTextClass}>
            {props.children}
        </p>
    );
};

export default ParagraphSecondary;
